// extracted by mini-css-extract-plugin
export default {"root":"TradeInFAQ_root__2NsqI"};